import brand from '@helpers/brand';
import fonts from '@helpers/fonts';
import { Device, from } from '@helpers/media';
import { getLuminance } from 'polished';
import styled, { css } from 'styled-components';
const Container = styled.span `
  --bgColor: ${brand.white};
  
  ${({ backgroundColor }) => css `
    --fgColor: ${getLuminance(backgroundColor) > 0.5 ? brand.black : brand.white};
  `}

  display: inline-flex;
  background: var(--bgColor);
  border-radius: 4px;
  color: var(--fgColor);
  ${fonts.matter.regular};
  font-size: 14px;
  height: 26px;
  letter-spacing: 0.08em;
  line-height: 1em;
  margin: 0;
  padding: 0 8px;
  place-content: center;
  place-items: center;
  text-transform: uppercase;
  white-space: nowrap;

  @media ${from(Device.Tablet)} {
    font-size: 16px;
    height: 32px;
    padding: 0 20px;
  }
`;
const BadgeStyles = {
    Container,
};
export default BadgeStyles;
